"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _phoneValidator = require("../../utils/phoneValidator");
var _phoneVerification = require("../../utils/phone-verification.utils");
var _Button = require("../../components/Button");
var _phoneNumber = require("../../utils/phone-number.utils");
var _PhoneInput = require("../../components/PhoneInput");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var phoneValidator = (0, _phoneValidator.phoneValidator)();
var fieldName = 'phoneNumber';
var PhoneNumberForm = _form.default.create({
  name: 'EditablePhoneNumber'
})(function (_ref) {
  var form = _ref.form,
    onSubmit = _ref.onSubmit,
    loading = _ref.loading,
    phoneNumber = _ref.phoneNumber;
  var getFieldDecorator = form.getFieldDecorator,
    isFieldValidating = form.isFieldValidating;
  var validationErrors = Object.values(form.getFieldsError()).some(function (v) {
    return v;
  });
  var isValidating = isFieldValidating(fieldName);
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    form.validateFieldsAndScroll(function (err, formValues) {
      if (err) {
        return;
      }
      onSubmit(_defineProperty({}, fieldName, (0, _phoneValidator.trimPhoneNumber)(formValues[fieldName])));
    });
  };
  return /*#__PURE__*/_react.default.createElement("form", {
    id: "phone-number-enter-form",
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-[24px]"
  }, getFieldDecorator(fieldName, {
    initialValue: _phoneNumber.PhoneNumberUtils.getNationalNumber(phoneNumber),
    rules: [{
      validator: phoneValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_PhoneInput.PhoneInput, {
    placeholder: "Enter phone number",
    name: fieldName,
    form: form,
    inputStyles: "rounded-[4px] border border-solid border-green1-50 !p-[14px] !shadow-none"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center justify-around"
  }, /*#__PURE__*/_react.default.createElement(_Button.PrimaryButton, {
    className: "w-[300px] h-[46px]",
    disabled: !(0, _lodash.isEmpty)(validationErrors) || loading || isValidating,
    onClick: handleSubmit
  }, "Send verification code")));
});
var PhoneNumberVerificationEnter = function PhoneNumberVerificationEnter(_ref2) {
  var loading = _ref2.loading,
    initialPhoneNumber = _ref2.phoneNumber,
    _ref2$onContinue = _ref2.onContinue,
    onContinue = _ref2$onContinue === void 0 ? _lodash.noop : _ref2$onContinue,
    _ref2$onCancel = _ref2.onCancel,
    onCancel = _ref2$onCancel === void 0 ? _lodash.noop : _ref2$onCancel,
    onDone = _ref2.onDone;
  var _useState = (0, _react.useState)(initialPhoneNumber),
    _useState2 = _slicedToArray(_useState, 2),
    phoneNumber = _useState2[0],
    setPhoneNumber = _useState2[1];
  var _useSendPhoneVerifica = (0, _phoneVerification.useSendPhoneVerificationCode)({
      onSuccess: function onSuccess(_ref3, params) {
        var verificationRequired = _ref3.verificationRequired;
        setPhoneNumber(params[0].phoneNumber);
        if (verificationRequired) {
          onContinue();
        } else {
          onDone();
        }
      }
    }),
    onSendPhoneVerificationCode = _useSendPhoneVerifica.onSend,
    sendingPhoneVerificationCode = _useSendPhoneVerifica.sending;
  var handleSubmit = function handleSubmit(payload) {
    onSendPhoneVerificationCode({
      phoneNumber: payload[fieldName]
    });
  };
  var isLoading = loading || sendingPhoneVerificationCode;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "text-text-black-100"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-subtitle-sm-medium mb-[24px] sm-max:mt-[32px] px-[20px] sm:px-[0px]"
  }, "Please enter your phone number"), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-light mb-[24px] sm-max:mt-[32px] px-[20px] sm:px-[0px]"
  }, "We\u2019ll send you a verification code via SMS"), /*#__PURE__*/_react.default.createElement(PhoneNumberForm, {
    loading: isLoading,
    phoneNumber: phoneNumber,
    onSubmit: handleSubmit,
    onCancel: onCancel
  }));
};
var _default = PhoneNumberVerificationEnter;
exports.default = _default;